import { createSelector } from '@reduxjs/toolkit';
import { selectModelEntities } from 'services/api/resources/selectors';
import { RootState } from 'services/store';
import { Model } from 'types/entities/Resources';

const selectRecentIds = (state: RootState) =>
  state.resourcesHistory.recentlyViewedIds;

export const selectRecentlyViewedModels = createSelector(
  [selectModelEntities, selectRecentIds],
  (entities, recentIds) =>
    recentIds
      .map(id => entities[id])
      .filter((model): model is Model => Boolean(model)),
);
